/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import {
  initializeFaro as initializeFaroSdk,
  getWebInstrumentations,
  LogLevel,
  Faro,
} from "@grafana/faro-web-sdk";
import { TracingInstrumentation } from "@grafana/faro-web-tracing";
import {
  API_BASE_URL,
  APP_ENVIRONMENT,
  FARO_PATH,
  FARO_VERSION,
} from "@src/config/constants";

let faroEnabled = false;
let faroInfoLogEnabled = false;

export const setFaroEnabled = (enabled: boolean) => {
  faroEnabled = enabled;
};

export const setFaroInfoLogEnabled = (enabled: boolean) => {
  faroInfoLogEnabled = enabled;
};

let faro: Faro | Record<string, never> = {};

export function initializeFaro(): void {
  const FARO_URL =
    APP_ENVIRONMENT === "development"
      ? `${window.location.origin}/${FARO_PATH}`
      : `https://api.${API_BASE_URL}/${FARO_PATH}`;

  if (!FARO_URL) return;

  faro = initializeFaroSdk({
    url: FARO_URL,
    app: {
      name: "CLINICIAN-UI",
      version: FARO_VERSION,
      environment: APP_ENVIRONMENT,
    },
    instrumentations: [
      ...getWebInstrumentations({ captureConsole: false }),
      new TracingInstrumentation(),
    ],
    beforeSend: (event) => {
      if (!faroEnabled) return null;
      const { level } = event.payload as { level: LogLevel };
      if (!faroInfoLogEnabled && event.type === "log") {
        if (level === LogLevel.INFO || level === LogLevel.DEBUG) return null;
      }
      return event;
    },
  });
}

export default faro;
